import { cache } from "@/api/api";
import { AppAbilityService } from "@/appAbility";

const userToken = "user-token";
const refreshToken = "refresh-token";

export const UserToken = {
  isLoggedOut: false,
  get() {
    return localStorage.getItem(userToken) || null;
  },
  getRefresh() {
    return localStorage.getItem(refreshToken) || null;
  },
  remove() {
    this.isLoggedOut = true;
    (cache.store as any).clear();
    sessionStorage.clear();
    localStorage.clear();
    AppAbilityService.update([]);
  },
  update(token: string) {
    localStorage.setItem(userToken, token);
  },
  updateRefresh(token: string) {
    localStorage.setItem(refreshToken, token);
  }
};
